import { supabase } from "~/integrations/supabase/client";

export interface BsaleFetchInit {
  method?: string;
  body?: unknown;
}

// Normalize either a "/v1"-relative path ("/documents.json?limit=1") or a full
// BSale URL ("https://api.bsale.io/v1/clients/5.json", as returned in BSale
// HATEOAS `href` fields) to a "/v1"-relative path.
function toBsalePath(input: string): string {
  const stripped = input.replace(/^https?:\/\/api\.bsale\.io\/v1/i, "");
  return stripped.startsWith("/") ? stripped : `/${stripped}`;
}

// Browser-side BSale call routed through the `bsale-proxy` edge function so the
// BSale access token never ships in the client bundle. Returns a standard
// `Response` so existing call sites keep using `.ok` / `.status` / `.json()`.
export async function bsaleFetch(
  pathOrUrl: string,
  init: BsaleFetchInit = {}
): Promise<Response> {
  const path = toBsalePath(pathOrUrl);
  const { data, error } = await supabase.functions.invoke("bsale-proxy", {
    body: { path, method: init.method ?? "GET", body: init.body },
  });

  if (error) {
    return new Response(JSON.stringify({ error: error.message }), {
      status: 502,
      headers: { "Content-Type": "application/json" },
    });
  }

  // The proxy wraps BSale's real status inside a 200 payload: { status, body }.
  const status = typeof data?.status === "number" ? data.status : 200;
  const bodyText =
    typeof data?.body === "string"
      ? data.body
      : JSON.stringify(data?.body ?? null);

  return new Response(bodyText, {
    status,
    headers: { "Content-Type": "application/json" },
  });
}
